import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

const styles = theme => ({
    textField: {
        marginLeft: 25,
        marginRight: 25,
    },
});
 

class CustomTextField  extends React.Component {
    
  constructor(props) {
    super(props); 
    console.log(props)
  }

    showError = () => {
        const {
              error, touched,
        } = this.props;
        if (touched && error) {
            return error;
        }
    };

    render() {
        const {
            id,
            type,
            input,
            classes,
            fullWidth,
            InputValue,
            disabled,
            error,
            touched, 
            onChange,
        } = this.props; 
        return (
                id == 'username' ?
                    <TextField
                        {...input}
                        id={id}
                        error={touched && error ? true : false}
                        className={classes.textField}
                        label={this.props.label}
                        helperText={this.showError()}
                        type={type}
                        autoFocus={true}
                        fullWidth={fullWidth}
                        value={InputValue}
                        onChange={onChange}
                        disabled={disabled}
                        margin="normal"
                    />
                    :
                    id == 'outlined-with-placeholder'?
                    <TextField
                    {...input}
                    id={id}  
                    error={touched && error ? true : false}
                    label={this.props.label}
                    placeholder={this.props.placeholder}
                    helperText={this.showError()}
                    type={type}
                    value={InputValue}
                    disabled={disabled}
                    fullWidth={fullWidth}  
                    onChange={onChange}

                    variant="outlined"
                            />
                            :
                    <TextField
                        {...input}
                        id={id}
                        error={touched && error ? true : false}
                        className={classes.textField}
                        label={this.props.label}
                        helperText={this.showError()}
                        type={type}
                        value={InputValue}
                        fullWidth={fullWidth}
                        disabled={disabled}
                        onChange={onChange}

                        margin="normal"
                    />
        );
    }
}

export default withStyles(styles)(CustomTextField);



// WEBPACK FOOTER //
// ./src/components/fields/CustomTextField.js